import React, { createContext } from 'react';

export const BackStageContext = createContext<{
  setBackStageUpdateTrigger: React.Dispatch<
    React.SetStateAction<Record<string, never>>
  >;
  backStageUpdateTrigger: Record<string, never>;
}>({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
  setBackStageUpdateTrigger: (triggerObj: Record<string, never>) => {
    console.log('setBackStageUpdateTrigger is not initialized');
  },
  backStageUpdateTrigger: {},
});
